import React from 'react';
import { Row } from 'reactstrap';
import { User } from '../../../../../../entities/User';
import { ScorecardLabel } from '../ScorecardLabel';
import { ScorecardAttributeValue } from '../../../../Scorecards/ScorecardPage/ScorecardBody/ScorecardCategories/ScorecardAttribute/ScorecardAttributeValue';
import {
  InterviewScorecardCategory,
  InterviewStageScorecard,
} from '../../../../../../entities/applicant_tracking/InterviewStage';
import classNames from 'classnames';

interface PropTypes {
  user: User;
  scorecard: InterviewStageScorecard;
}

export function ScorecardCategories(props: PropTypes) {
  return (
    <Row>
      {props.scorecard.categories.map(
        (category: InterviewScorecardCategory, index: number) => {
          return (
            <div key={index} className='w-100'>
              <ScorecardLabel
                classNames={classNames(index != 0 && 'mt-4', 'mb-3h')}
                title={category.name}
                label={'1-5 Scale Rating'}
              />
              <div className='d-flex flex-column gap-2'>
                {category.attributes.map(
                  (attribute: string, attrIndex: number) => (
                    <ScorecardAttributeValue
                      key={attrIndex}
                      id={`${category.id}_${attrIndex}`}
                      rating={5}
                      editable={false}
                      name={attribute}
                      fillColorClass='text-blue-gray-500'
                    />
                  ),
                )}
              </div>
            </div>
          );
        },
      )}
    </Row>
  );
}
